import { Language } from '@/services/interfaces/Translation';

/**
 * Configuration options for the Realtime API service
 */
export interface SessionServiceConfig {  
  
  /**
   * Voice to use for text-to-speech
   * 'alloy', 'echo', 'fable', 'onyx', 'nova', 'shimmer'
   */
  voice: string;
  
  /**
   * Instructions for the AI model
   */
  instructions: string;

  microphoneDeviceId: string;

  sourceLanguage: Language;
  targetLanguage: Language;

}

/**
 * Status of the Realtime API connection
 */
export enum SessionConnectionStatus {
  Disconnected = 'disconnected',
  Connecting = 'connecting',
  Connected = 'connected',
  Error = 'error'
}

/**
 * Session information for the Realtime API
 */
export interface SessionInfo {
  id: string; // Azure session ID
  chatSessionId?: string; // Chat session ID for saving conversations
  startTime: number;
  status: SessionConnectionStatus;
  error?: Error;
  ephemeralKey?: string;
  webrtcUrl?: string;
  deployment?: string;
}
